import * as angular from "angular";
import {userService} from "./common/user/user.service";
import {groupsService} from "./common/groups/groups.service";
import {institutionService} from "./common/institution/institution-service";
import {groupsInitService} from "./groups/groups-init/groups-init.service";
import {messagingService} from "./common/messaging/messaging.service";
import {studentsService} from "./common/students/students.service";
import {studyProgramsService} from "./common/study-programs/study-programs.service";
import {navigationMenuService} from "./common/top-nav/navigation-menu.service";
import {instructorsService} from "./common/instructors/instructors.service";
import {UserSessionService} from "./common/user-session/user-session.service";
import {preferenceService} from "./common/preference/preference.service";
import {layoutInitService} from "./layout-init/layout-init.service";
import {featureService} from "./common/feature/feature.service";
import {TypeaheadProviderService} from "./common/typeahead-provider/typeahead-provider.service";
import {CookieMonsterService} from "./cookie-monster/cookie-monster.service";
import {InsightsPopoverService} from "./insights/insights-popover.service";

export function initServices(app: angular.IModule) {
    app.service("userService", userService);
    app.service("groupsService", groupsService);
    app.service("studentsService", studentsService);
    app.service("institutionService", institutionService);
    app.service("groupsInitService", groupsInitService);
    app.service("messagingService", messagingService);
    app.service("studyProgramsService", studyProgramsService);
    app.service("navigationMenuService", navigationMenuService);
    app.service("instructorsService", instructorsService);
    app.service("userSessionService", UserSessionService);
    app.service("preferenceService", preferenceService);
    app.service("layoutInitService", layoutInitService);
    app.service("featureService", featureService);
    app.service("typeaheadProviderService", TypeaheadProviderService);
    app.service("cookieMonsterService", CookieMonsterService);
    app.service("insightsPopoverService", InsightsPopoverService);
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/app.services.ts
 **/